<span
  class="wp-replacement-label"
  (click)="activate($event)"
  tabindex="-1"
  attr.data-qa-selector="{{fieldName}}">
  <ng-content></ng-content>
</span>
